import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "./filters.scss";
import Checkbox from "../Checkbox";
import Row from "../Row";
import Col from "../Col";
import FontAwesomeIcon from "../Icon";
import Button from "../Button";
import moment from "moment";
import { variables } from "../../Tenants";
import { Multiselect } from "multiselect-react-dropdown";
import { fetchServicesProviderAndPropertyDeveloperList } from "../../store/actions/FilterServiceProviderandPropertyDeveloperList";
import { useDispatch, useSelector } from "react-redux";
import { selectPropertyCommonAreasForFilterDone } from "../../store/actions/properties";
import Select from "react-select";
import { fetchServiceRequestTags } from "../../store/actions/formOptions";

export const Filters = (props) => {
  const dispatch = useDispatch();
  const FilterServiceProviderandPropertyDeveloperList = useSelector(
    (state) => state.FilterServiceProviderandPropertyDeveloperList
  );
  const auth = useSelector((state) => state.auth);
  const roleName = auth.user.roles[0].role.name;
  const roleCondition =
    roleName === "Admin" ||
    roleName === "Super Admin" ||
    roleName === "Property Developer" ||
    roleName === "Service Manager" ||
    roleName === "Strata Manager";
  const propertyCommonAreas = useSelector(
    (state) =>
      state.FilterCommonAreas &&
      state.FilterCommonAreas.fetchedPropertyCommonAreas
  );
  const propertyCommonAreasData =
    propertyCommonAreas && propertyCommonAreas.commonAreas;
  const commonAreasData = propertyCommonAreasData || [];

  const selectedPropertyCommonAreas = useSelector(
    (state) =>
      state.FilterCommonAreas &&
      state.FilterCommonAreas.selectedPropertyCommonAreas
  );
  const serviceRequestTags = useSelector(
    (state) => state.formOptions.serviceRequestTags || []
  );
  const {
    onClose,
    filterValues,
    setFilterData,
    properties,
    issueTypes,
    assetTypes,
    getBuildings,
    buildingsList,
    getBuildingsLevels,
    levelsList,
    getPropertySuites,
    propertySuites,
    getPropertyCommonAreas,
  } = props;

  const walkthroughType =
    filterValues.walkthrough && filterValues.walkthrough.length > 0
      ? filterValues.walkthrough
      : [];
  const [checkedConstruction, setCheckedConstruction] = useState(
    walkthroughType.find((item) => item === "Construction Walk-through")
      ? true
      : false
  );
  const [checkedDeveloper, setCheckedDeveloper] = useState(
    walkthroughType.find((item) => item === "Developer Walk-through")
      ? true
      : false
  );
  const [checkedHomeowner, setCheckedHomeowner] = useState(
    walkthroughType.find((item) => item === "Home Owner Walk-through")
      ? true
      : false
  );
  const [checkedServiceRequests, setcheckedServiceRequests] = useState(
    walkthroughType.find((item) => item === "Regular Service Requests")
      ? true
      : false
  );
  const [checkedOneYearWarrantyIssue, setCheckedOneYearWarrantyIssue] =
    useState(
      walkthroughType.find((item) => item === "One Year Warranty Issue")
        ? true
        : false
    );
  const [internal, setInternal] = useState(
    walkthroughType.find((item) => item === "Internal") ? true : false
  );
  const [homeownerOrOccupant, setHomeownerOROccupant] = useState(
    walkthroughType.find((item) => item === "Homeowner or Occupant")
      ? true
      : false
  );
  const [group, setGroup] = useState(
    walkthroughType.find((item) => item === "Group") ? true : false
  );

  const [startDate, setStartDate] = useState(
    filterValues?.startDate ? moment(filterValues?.startDate).toDate() : null
  );
  const [endDate, setEndDate] = useState(
    filterValues?.endDate ? moment(filterValues?.endDate).toDate() : null
  );
  const [project, setProject] = useState(filterValues?.project);
  const [commonAreas, setCommonAreas] = useState(filterValues?.commonAreas);
  const [issueType, setIssueType] = useState(filterValues?.issueType);
  const [assetType, setAssetType] = useState(filterValues?.assetType);
  const [building, setBuilding] = useState(filterValues?.building);
  const [level, setLevel] = useState(filterValues?.level);
  const [suite, setSuite] = useState(filterValues?.suite);
  const [tags, setTags] = useState(filterValues?.tags);
  const [assignTo, setAssignTo] = useState(filterValues?.assignTo);

  // const [assetValues, setAssetValues] = useState(modifyAsset());

  function modifyAsset() {
    let assets = [
      ...new Map(assetTypes.map((item) => [item["typeName"], item])).values(),
    ];
    return assets;
  }

  function filterList(selectedList, selectedItem) {
    let list = [];
    for (var i = 0; i < selectedList.length; i++) {
      list.push({
        Id: selectedList[i].Id,
        name: selectedList[i].name,
      });
    }
    setSuite(list);
  }

  const onSetTags = (newValue, actionMeta) => {
    setTags(newValue);
  };
  useEffect(() => {
    fetchData();
    dispatch(fetchServiceRequestTags());
  }, []);

  const fetchData = async () => {
    let loginUserId = auth.user.id;
    let role = auth.user.roles[0].role.name;
    await dispatch(
      fetchServicesProviderAndPropertyDeveloperList(loginUserId, role)
    );
  };
  function handleSubmit() {
    dispatch(
      selectPropertyCommonAreasForFilterDone(propertyCommonAreas.commonAreas)
    );
    let filterData = { ...filterValues };
    let walkthroughTypes = [];
    if (checkedConstruction) walkthroughTypes.push("Construction Walk-through");
    if (checkedDeveloper) walkthroughTypes.push("Developer Walk-through");
    if (checkedHomeowner) walkthroughTypes.push("Home Owner Walk-through");
    if (checkedServiceRequests)
      walkthroughTypes.push("Regular Service Requests");
    if (checkedOneYearWarrantyIssue)
      walkthroughTypes.push("One Year Warranty Issue");
    if (internal) walkthroughTypes.push("Internal");
    if (homeownerOrOccupant) walkthroughTypes.push("Homeowner or Occupant");
    if (group) walkthroughTypes.push("Group");

    // setFilterData("Walkthrough", walkthroughTypes);
    filterData.walkthrough = walkthroughTypes;

    if (startDate || endDate) {
      // setFilterData("StartDate", startDate ? moment(startDate).format("l") : moment(endDate).format("l"));
      // setFilterData("EndDate", endDate ? moment(endDate).format("l") : moment(startDate).format("l"));
      filterData.startDate = startDate
        ? moment(startDate).format("MM-DD-YYYY")
        : moment(endDate).format("MM-DD-YYYY");
      filterData.endDate = endDate
        ? moment(endDate).format("MM-DD-YYYY")
        : moment(startDate).format("MM-DD-YYYY");
    }
    filterData.project = project;
    filterData.suite = suite;
    filterData.issueType =
      issueType === "Heating/Cooling" ? "Heating&Cooling" : issueType;
    filterData.assetType = assetType;
    filterData.building = building;
    filterData.level = level;
    filterData.assignTo = assignTo;
    filterData.commonAreas =
      typeof commonAreas === "object" ? commonAreas.id : commonAreas;
    filterData.tags = tags;
    setFilterData(filterData);
    onClose();
    //this.setState({ openFiltersModal: false });
  }

  return (
    <>
      <div className="filters-modal__heading">Filter By</div>
      <div className="filters_modal_top_coner_box">
        <div className="filters_modal_close_icon" onClick={onClose}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
              fill="black"
            />
          </svg>
        </div>
      </div>

      <Checkbox
        label={"Construction walkthrough"}
        value={checkedConstruction}
        onChange={() => {
          setCheckedConstruction(!checkedConstruction);
        }}
      />
      <Checkbox
        label={"Developer walkthrough"}
        value={checkedDeveloper}
        onChange={() => {
          setCheckedDeveloper(!checkedDeveloper);
        }}
      />
      <Checkbox
        label={"Homeowner walkthrough"}
        value={checkedHomeowner}
        onChange={() => setCheckedHomeowner(!checkedHomeowner)}
      />
      <Checkbox
        label={`Regular ${variables.serviceRequest}s`}
        value={checkedServiceRequests}
        onChange={() => setcheckedServiceRequests(!checkedServiceRequests)}
      />
      <Checkbox
        label={"One Year Warranty Issue"}
        value={checkedOneYearWarrantyIssue}
        onChange={() =>
          setCheckedOneYearWarrantyIssue(!checkedOneYearWarrantyIssue)
        }
      />
      {/* 
      
       // Modified by: Tarkeshwar Prasad Yadav
      // Modified on: 30/08/2022
      // Jira ticket: JUN-3129
      // Comment: Added ServiceRequest Filter - as Internal and Homeowner or Occupant.
 
      */}
      <Checkbox
        label={"Internal"}
        value={internal}
        onChange={() => setInternal(!internal)}
      />
      <Checkbox
        label={"Homeowner or Occupant"}
        value={homeownerOrOccupant}
        onChange={() => setHomeownerOROccupant(!homeownerOrOccupant)}
      />
      <Checkbox
        label={"Group"}
        value={group}
        onChange={() => setGroup(!group)}
      />
      <Row style={{ marginBottom: "15px" }}>
        <Col md={6} xs={6}>
          <div className="filters-modal__label" style={{ marginTop: "15px" }}>
            Start Date
          </div>
          <div className="filters-modal-picker__datepicker">
            <div className="filters-modal-picker__chevron">
              <FontAwesomeIcon glyph="calendar" weight="light" />
            </div>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                // console.log("StartDate", moment(date).format("l"));
                // setFilterData("StartDate",moment(date).format("l"))
                setStartDate(date);
              }}
              onFocus={(e) => (e.target.readOnly = true)}
              popperPlacement="top-start"
              // className="react-datepicker"
            />
          </div>
        </Col>
        <Col md={6} xs={6}>
          <div className="filters-modal__label" style={{ marginTop: "15px" }}>
            End Date
          </div>
          <div className="filters-modal-picker__datepicker">
            <div className="filters-modal-picker__chevron">
              <FontAwesomeIcon glyph="calendar" weight="light" />
            </div>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                // console.log("StartDate", moment(date).format("l"));
                // setFilterData("EndDate",moment(date).format("l"))
                setEndDate(date);
              }}
              onFocus={(e) => (e.target.readOnly = true)}
              popperPlacement="top-start"
            />
          </div>
        </Col>
      </Row>

      <div className="filters-modal__label">Project</div>
      <select
        defaultValue=""
        onChange={(e) => {
          getBuildings(e.target.value);
          getPropertySuites(e.target.value);
          setProject(e.target.value);
          setCommonAreas("");
        }}
        value={project}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select Project
        </option>
        {properties.map((item, i) => (
          <option value={item.propertyId}>{item.name}</option>
        ))}
      </select>

      <div className="filters-modal__label">Common Areas</div>
      <select
        defaultValue=""
        onChange={(e) => {
          setCommonAreas(e.target.value);
        }}
        value={commonAreas}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select common area
        </option>
        {commonAreasData.map((item, i) => (
          <option value={item.id}>{item.name}</option>
        ))}
      </select>

      <div className="filters-modal__label">{variables.Suite}(s)</div>
      <div className="multi">
        <Multiselect
          id="suites"
          options={
            project
              ? propertySuites.map((item, i) => ({
                  Id: item.id,
                  name: item.number,
                }))
              : []
          }
          selectedValues={suite}
          displayValue="name"
          placeholder={`Select ${variables.Suite}`}
          onSelect={filterList}
          onRemove={filterList}
          disable={project ? false : true}
        />
      </div>
      <div className="filters-modal__label" style={{ marginTop: 15 }}>
        Issue Type
      </div>
      <select
        defaultValue=""
        // className={classNames("select__bulkUpdate_options", {
        //   "select__bulkUpdate_options--background":
        //     this.state.selectedIds.length > 0 ? true : false,
        // })}
        //  style={{ backgroundColor: this.state.selectedIds.length > 0 ? '#00848e' : 'grey' }}
        // disabled={this.state.selectedIds.length > 0 ? false : true}
        onChange={(e) => setIssueType(e.target.value)}
        value={issueType}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select Issue type
        </option>
        {issueTypes.map((type, i) => (
          <option value={type.name}>{type.name}</option>
        ))}
      </select>

      <div className="filters-modal__label">Asset Type</div>
      <select
        defaultValue=""
        onChange={(e) => setAssetType(e.target.value)}
        value={assetType}
        className="filters-modal-select"
      >
        <option selected="true" disabled="disabled" value="">
          Select Asset type
        </option>
        {modifyAsset().map((type, i) => (
          <option value={type.typeId}>{type.typeName}</option>
        ))}
      </select>

      <div className="filters-modal__label">Building</div>
      <select
        defaultValue=""
        onChange={(e) => {
          getBuildingsLevels(e.target.value);
          setBuilding(e.target.value);
        }}
        value={building}
        className="filters-modal-select"
        disabled={project ? false : true}
      >
        <option selected="true" disabled="disabled" value="">
          Select Building
        </option>
        {buildingsList.map((item, i) => (
          <option value={item.id}>{item.building}</option>
        ))}
      </select>

      <div className="filters-modal__label">Level</div>
      <select
        defaultValue=""
        onChange={(e) => setLevel(e.target.value)}
        value={level}
        className="filters-modal-select"
        disabled={building ? false : true}
      >
        <option selected="true" disabled="disabled" value="">
          Select Level
        </option>
        {levelsList.map((item, i) => (
          <option value={item.id}>{item.level}</option>
        ))}
      </select>

      {roleCondition ? (
        <>
          <div className="filters-modal__label">Assigned To</div>
          <select
            defaultValue=""
            onChange={(e) => setAssignTo(e.target.value)}
            value={assignTo}
            className="filters-modal-select"
          >
            <option selected="true" disabled="disabled" value="">
              Select Assigned To
            </option>
            {FilterServiceProviderandPropertyDeveloperList.payload.length >
            0 ? (
              FilterServiceProviderandPropertyDeveloperList.payload.map(
                (type, i) => (
                  <option
                    value={type.id}
                  >{`${type.firstname}  ${type.lastname}`}</option>
                )
              )
            ) : (
              <option>No data</option>
            )}
          </select>
        </>
      ) : null}
      
      <div className="filters-modal__label">{"Tags"}</div>
      <div style={{ marginBottom: 20 }}>
        <Select
          menuPlacement="top"
          placeholder="Select Tags"
          closeMenuOnSelect={false}
          isClearable
          isMulti
          options={
            serviceRequestTags.length > 0
              ? serviceRequestTags.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))
              : []
          }
          value={tags}
          onChange={(newValue, actionMeta) => onSetTags(newValue, actionMeta)}
        />
      </div>

      <div style={{ textAlign: "center" }}>
        <Button
          color="teal"
          label="Submit"
          size="small"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};
